import { BeatSpinner } from ".";
import FavLogo from "../../assets/logo.png";

const FavaloroSpinner = () => <BeatSpinner src={FavLogo} />;

export default FavaloroSpinner;
